import Home from './pages/Home/Home'
import React from 'react'
import { I18nProvider } from './i18n/I18nContext'
function App() {
  return (
    <I18nProvider>
      <Home></Home>
    </I18nProvider>
  )
}

export default App
